import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[appModal]',
    standalone: true,
})
export class ModalDirective {
    viewContainerRef = inject(ViewContainerRef);
}
